import { useStore } from "../store.js";

/** Shown on a blank ledger: a calm prompt to start building or load the demo. */
export function EmptyState() {
  const loadDemo = useStore((state) => state.loadDemo);

  return (
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
      <div className="pointer-events-auto max-w-sm rounded-2xl border border-node-border bg-node-bg/95 p-8 text-center shadow-2xl backdrop-blur">
        <h2 className="text-lg font-semibold text-ink">A blank canvas</h2>
        <p className="mt-2 text-sm text-ink-muted">
          Add your accounts, cards and bills with the <span className="text-ink">+ Add node</span>{" "}
          button, then wire them together. Or start from the example setup.
        </p>
        <button
          type="button"
          onClick={() => void loadDemo()}
          className="mt-5 rounded-lg bg-accent px-4 py-2 text-sm font-medium text-canvas hover:opacity-90"
        >
          Load demo data
        </button>
      </div>
    </div>
  );
}
